module.exports = __webpack_public_path__ + "img/domain-banner-health.95a7f400.svg";